import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { useSelector } from "react-redux";

export default function SettingsPopUp() {
  const user = useSelector((state) => state.user);
  const userInfo = user?.userInfo;
  const userData = user?.user;

  // Format last sign in date
  const formatLastSignIn = () => {
    if (userData?.auth_time) {
      const date = new Date(userData.auth_time * 1000);
      return {
        date: date.toLocaleDateString(),
        time: date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
      };
    }
    return { date: 'N/A', time: '' };
  };

  const lastSignIn = formatLastSignIn();

  return (
    <Menu as="div" className="relative inline-block text-left">
      <div className="flex items-center">
        <Menu.Button className="">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="icon">
              <path
                id="Star 5"
                d="M10.0285 3.91752C10.9596 2.49801 13.0404 2.49801 13.9715 3.91752C14.653 4.9566 15.8526 5.53433 17.0899 5.4193C18.7803 5.26216 20.0777 6.88906 19.5483 8.50201C19.1609 9.6827 19.4571 10.9808 20.3185 11.8765C21.4953 13.1 21.0322 15.1287 19.4411 15.7206C18.2765 16.1538 17.4463 17.1948 17.2831 18.4267C17.0602 20.1096 15.1854 21.0124 13.7306 20.1374C12.6658 19.497 11.3342 19.497 10.2694 20.1374C8.81464 21.0124 6.93984 20.1096 6.71691 18.4267C6.55373 17.1948 5.72354 16.1538 4.55886 15.7206C2.96776 15.1287 2.50473 13.1 3.68148 11.8765C4.54285 10.9808 4.83915 9.6827 4.45168 8.50201C3.92234 6.88906 5.21975 5.26216 6.91006 5.4193C8.14736 5.53433 9.34702 4.95661 10.0285 3.91752Z"
                stroke="currentColor"
              />
              <circle
                id="Ellipse 165"
                cx="12"
                cy="12"
                r="3.5"
                stroke="currentColor"
              />
            </g>
          </svg>{" "}
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-10 mt-2 min-w-max origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="p-4">
            <table className="border-separate border-spacing-y-3">
              <tbody>
                <tr>
                  <td className="text-text-hint pr-6 align-top whitespace-nowrap">User Name</td>
                  <td className="font-medium text-black">
                    {[userInfo?.first_name, userInfo?.last_name].filter(Boolean).join(' ') || userData?.name || userData?.email || 'N/A'}
                  </td>
                </tr>
                <tr>
                  <td className="text-text-hint pr-6 align-top whitespace-nowrap">Email</td>
                  <td className="font-medium text-black">{userInfo?.email_id || userData?.email || 'N/A'}</td>
                </tr>
                <tr>
                  <td className="text-text-hint pr-6 align-top whitespace-nowrap">Client</td>
                  <td className="font-medium text-black">{userInfo?.client_name || 'N/A'}</td>
                </tr>
                <tr>
                  <td className="text-text-hint pr-6 align-top whitespace-nowrap">Company</td>
                  <td className="font-medium text-black">{userInfo?.company_name || 'N/A'}</td>
                </tr>
                <tr>
                  <td className="text-text-hint pr-6 align-top whitespace-nowrap">Last Sign In</td>
                  <td className="font-medium text-black">
                    {lastSignIn.date}{lastSignIn.time && `, ${lastSignIn.time}`}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
